module.exports = __webpack_public_path__ + "img/D5-1-1-img01.e47fc391.jpg";